import _URLSearchParams from "@babel/runtime-corejs3/core-js/url-search-params";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import { retrieveApplicationinfo } from "@Client/@Modules/main/api/account-api";
import { getPublicApi } from "@Shared/@Utils/ajax";
import { ACCOUNTS_API_PUBLIC } from "@Shared/@Utils/constants";
import { isObjectWithEmptyProperties } from "@Shared/@Utils/utils";
import { isEmpty } from "lodash";
import DOMPurify from "dompurify";
export const decodeParamAsObject = encodedBase64String => {
  if (!encodedBase64String) return {};
  const decoded = atob(decodeURIComponent(encodedBase64String));
  return JSON.parse(decoded);
};
export const decodeDetailsToken = async ({
  token,
  params
}) => {
  const {
    isGhost,
    email: emailFromShare,
    applicationId,
    givenName = "",
    familyName = "",
    phoneNumber = "",
    locale = "en-CA"
  } = token ? await retrieveApplicationinfo(token) : decodeParamAsObject(params);
  return {
    isGhost,
    emailFromShare,
    applicationId,
    givenName,
    familyName,
    phoneNumber,
    locale
  };
};

/**
 * A token containing a customizationId is sometimes used to avoid broken
 * links because brokers change their subdomain, if thats the case ask
 * backend for the correct subdomain
 */
export const checkSubdomainRedirectionToken = async () => {
  //Before any further check, if a token is provided then the subdomain should be retrieved from there
  let urlToken = new _URLSearchParams(DOMPurify.sanitize(window.location.hash).split("?")[1]).get("t");
  if (!urlToken) {
    //The token can also be in the params queryParam
    let paramsToken = new _URLSearchParams(DOMPurify.sanitize(window.location.hash).split("?")[1]).get("params");
    //Verify that it is an actual jwt and not just raw base64
    if (paramsToken && paramsToken.split(".").length === 3) {
      urlToken = paramsToken;
    } else {
      return false;
    }
  }

  //Ask the backend for the correct subdomain
  const {
    subdomain
  } = await getPublicApi({
    t: urlToken
  }, `${ACCOUNTS_API_PUBLIC}/accounts/subdomain`);

  //Token may not be valid / contain a customizationId
  if (subdomain) {
    //Replaces subdomain in the current URL leaving the rest as is
    const hash = DOMPurify.sanitize(window.location.hash);
    window.location.href = `/${subdomain}${hash}`;
  }
  return subdomain;
};
export const getColumnsWithValues = (columns, values) => {
  return _filterInstanceProperty(columns).call(columns, ({
    visible,
    key
  }) => visible && !!values[key] && !isObjectWithEmptyProperties(values[key]));
};
export const getRowsWithValues = (rows, data, multi) => {
  return _filterInstanceProperty(rows).call(rows, row => row.visible && !isRowEmpty(row, data, multi));
};
const isRowEmpty = (row, data, multi) => {
  if (multi) {
    return _Object$values(data).every(item => {
      const values = row.columns[0].subGroup ? item[row.subGroup] : item;
      return isEmpty(getColumnsWithValues(row.columns, values));
    });
  }
  return isEmpty(getColumnsWithValues(row.columns, data));
};